import React, { JSX } from 'react';

import { EventOperatorRow } from '../types';
import { formatOperatorLabel } from '../utils';

type Props = {
  eventId: string;
  operators: EventOperatorRow[];
  isAdmin: boolean;
  isReadOnly: boolean;
  lockedHint: string;
  onOpenAssignOperatorDialog: (eventId: string) => void;
  onRemoveOperator?: (eventId: string, userId: string) => void;
};

export default function EventAssignedOperatorsInline(props: Props): JSX.Element {
  const {
    eventId,
    operators,
    isAdmin,
    isReadOnly,
    lockedHint,
    onOpenAssignOperatorDialog,
    onRemoveOperator,
  } = props;

  return (
    <div className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
      {operators.length === 0 ? (
        <div className="text-sm text-gray-600 dark:text-slate-400 flex items-center gap-2">
          <span className="font-semibold text-gray-900 dark:text-slate-100">Assigned operators:</span>
          No operators assigned.
          {isAdmin ? (
            <button
              type="button"
              className="inline-flex items-center justify-center h-5 w-5 rounded border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-xs font-semibold text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={isReadOnly}
              title={isReadOnly ? lockedHint : 'Add operator'}
              aria-label="Add operator"
              onClick={() => {
                if (isReadOnly) return;
                onOpenAssignOperatorDialog(eventId);
              }}
            >
              +
            </button>
          ) : null}
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-semibold text-gray-900 dark:text-slate-100">Assigned operators:</span>
          {operators.map((op) => (
            <div
              key={op.userId}
              className="inline-flex max-w-full items-center gap-2 rounded-full border border-gray-300 bg-gray-50 px-3 py-1 text-xs text-gray-800 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
            >
              <svg
                className="h-3.5 w-3.5 text-gray-500 dark:text-slate-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M10 2a4 4 0 100 8 4 4 0 000-8zM3 16a7 7 0 1114 0v1H3v-1z" />
              </svg>
              <span className="truncate">{formatOperatorLabel(op)}</span>
              {isAdmin && onRemoveOperator ? (
                <button
                  type="button"
                  disabled={isReadOnly}
                  className="inline-flex items-center justify-center h-4 w-4 rounded-full border border-red-300 bg-red-50 text-[10px] font-semibold text-red-800 hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-50 dark:border-red-700/60 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-900/50 dark:disabled:hover:bg-red-950/40"
                  title={isReadOnly ? lockedHint : 'Remove operator'}
                  aria-label="Remove operator"
                  onClick={() => {
                    if (isReadOnly) return;
                    onRemoveOperator(eventId, op.userId);
                  }}
                >
                  ×
                </button>
              ) : null}
            </div>
          ))}
          {isAdmin ? (
            <button
              type="button"
              className="inline-flex items-center justify-center h-5 w-5 rounded border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-xs font-semibold text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={isReadOnly}
              title={isReadOnly ? lockedHint : 'Add operator'}
              aria-label="Add operator"
              onClick={() => {
                if (isReadOnly) return;
                onOpenAssignOperatorDialog(eventId);
              }}
            >
              +
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}
